module.exports = __webpack_public_path__ + "img/mine.e4cb3ecf.jpg";